import styled from 'styled-components';

export const Paragraph = styled('span')<{ expanded: boolean }>`
  ${(props) => (props.expanded ? 'display:block;' : '')}
  margin-bottom: 16px;
`;
